import { getFullName } from "encamp-shared/src/utils/name";
import { useCallback, useEffect, useMemo } from "react";
import { useLocation } from "react-router-dom";

import { useCurrentUser } from "../hooks/useCurrentUser";
import { useTenant } from "../hooks/useTenant";

type AppcuesUserInformation = {
  firstName?: string | null;
  lastName?: string | null;
  displayName: string;
  email: string;
  organization: string;
  tenantId: string;
  isStaff: boolean;
};

export function Appcues() {
  const { user, isStaff } = useCurrentUser();
  const { tenant } = useTenant();
  const location = useLocation();

  const userInfo = useMemo(() => {
    if (user && tenant) {
      const info: AppcuesUserInformation = {
        firstName: user.person?.first,
        lastName: user.person?.last,
        displayName: getFullName(user.person),
        email: user.email,
        organization: tenant.name,
        tenantId: tenant.id,
        isStaff,
      };

      return info;
    }
    return undefined;
  }, [user, tenant, isStaff]);

  const handleScriptLoad = useCallback(() => {
    if (user && userInfo && window.Appcues) {
      window.Appcues.identify(user.id, userInfo);
    }
  }, [user, userInfo]);

  const handleScriptError = () => {
    console.error("Could not load Appcues");
  };

  useEffect(() => {
    const scriptSrc = "//fast.appcues.com/117798.js";
    const existingScript = Array.from(document.getElementsByTagName("script")).find(
      (s) => s.src && s.src.includes("fast.appcues.com/117798.js")
    );
    if (!existingScript) {
      const script = document.createElement("script");
      script.src = scriptSrc;
      script.async = true;
      script.onload = handleScriptLoad;
      script.onerror = handleScriptError;
      document.body.appendChild(script);
    }
  }, [handleScriptLoad]);

  useEffect(() => {
    if (window.Appcues) {
      window.Appcues.page();
    }
  }, [location.pathname]);

  return null;
}
